import artwork from '../generated/app-artwork.json';
export const appArtwork=artwork as Record<string,{image:string;storeUrl:string;name:string;bundleId:string}>;
